import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Modal,
  connect,
} from "../../../atoms/DependencyHelper";

import LabelText from "../../../atoms/label/LabelText";
import { LabelConfiguration } from "../../../../services/labelBackgroundService";
import Image from "../../../atoms/image/image";
import ButtonWithIcon from "../../../atoms/buttons/buttonWithIcon/ButtonWithIcon";
import CartProductOptions from "../../../molecules/cartProductOptions/CartProductOptions";
import labels from "../../../../config/labels";
import ChangeLabelWithOutOfStock from "../../../molecules/changeLabel/ChangeLabelWithOutOfStock";

import IconWithText from "../../../molecules/iconWithText/IconWithText";
import StepCounter from "../../../atoms/stepCounter/StepCounter";

import {
  formatNumbersWithComma,
  componentResize,
  showSpinner,
  hideSpinner,
  getSelectedVariant,
  options,
  imagePrefix,
  componentCheckSize,
  createMarkup,
} from "../../../../utils/helperServices";
import ajaxService from "../../../../utils/ajaxServices";
import { getAttributes } from "../../../../config/queries";

import { getHighlights } from "../../../../services/dealService";

import ConfirmModal from "../../../atoms/confirmModal/ConfirmModal";

import {
  updateItemsofCart,
  deleteItemsFromCheckout,
} from "../../../../Redux/actions/cartAction";

import * as Analytics from "../../../../services/analyticsUtag";
import styles from "./InlineItem.module.scss";

const InlineItem = ({
  customerStatus,
  cartId,
  dealSku,
  paymentTerms,
  cartProduct,
  updateItemsofCart,
  displaySnackBar,
  deleteItemsFromCheckout,
}) => {
  const isTablet = componentCheckSize() < 768;
  const isMobile = componentResize();
  const selectedQuantity = cartProduct.quantity;
  const [showModal, setShowModal] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmModalContent, setConfirmModalContent] = useState("");
  const [updatedOptionsAttributes, setUpdatedOptionsAttributes] = useState([]);
  const [optionsAttributes, setOptionsAttributes] = useState([]);

  const [updatePage, setUpdatePage] = useState(false);
  const [dealOptions, setDealOptions] = useState([]);

  const isDealProduct =
    cartProduct?.product?.is_deal_product === 1 ? true : false;

  const isVASProduct =
    dealSku && cartProduct?.parent_product_sku == dealSku ? true : false;

  const buyOptionId = cartProduct?.config_custom_options?.[0]?.id;
  const buyOptionTypeId =
    cartProduct?.config_custom_options?.[0]?.values?.[0]?.value;
  const customizable_options = buyOptionId && buyOptionTypeId
    ? [{
        id: buyOptionId,
        value_string: buyOptionTypeId?.toString(),
      }]
    : [];

  useEffect(() => {
    if (isDealProduct) {
      const fetchData = async () => {
        try {
           const result = await ajaxService.fetchGraphQLPOSTRequest(
              getAttributes,
              { sku: cartProduct?.product?.primary_product_sku }
           );
           
           
           if ( Array.isArray(result?.products?.items) && 
                Array.isArray(result?.products?.attribute_set_config) &&
                result?.products?.items.length > 0 &&
                result?.products?.attribute_set_config.length > 0 )
            {
              const config = result?.products?.attribute_set_config;
              const items = result?.products?.items || [];
              const attributeCode = items[0]?.attribute_set_id;

              const attributeVals = config
                ?.find((val) => val.attribute_set_id == attributeCode)
                ?.configurable_product_attribute_set_attributes?.split(",");

              const updatedLabels = attributeVals?.map((val) => `${val}_label`);

              const dealArray = [];
              
                  for (const attr of items) {
                      for (const label of updatedLabels) {
                        dealArray.push(attr[label]);
                      }
                  }
              
              setDealOptions(dealArray);
           }
        } catch (error) {
            console.error("Error fetching attributes for deal:", error);
        }
      };
      fetchData();
    }
  }, []);

  const { name, __typename, primary_product_name } = cartProduct?.product || {};
  const { row_total_including_tax, row_total_original } = cartProduct?.prices || {};

  const optList = [];

  if ( __typename === labels.lbl_product_typeName_configurable
    && cartProduct?.product?.variants !== undefined
    && cartProduct?.product?.variants?.length > 0
  ) {
    const optionsList = cartProduct?.product?.configurable_options.map((val) => {
      const { attribute_code, attribute_id } = val || {};

      return {
        attribute_code,
        attribute_id,
      };
    });

    optionsList.forEach((option) => {
      let optionVal = options(
        cartProduct?.product?.configurable_options,
        option.attribute_code
      );

      optionVal = optionVal.map((opt) => {
        const { label, swatch_data, value_index } = opt || {};

        return {
          label,
          swatch_data,
          value_index,
          attribute_id: option.attribute_id,
        };
      });

      const variantsProducts = cartProduct?.product?.variants;

      const inStockOptionList = [];

      for (const oVal of optionVal) {
        for (const variant of variantsProducts) {
          for (const attr of variant.attributes) {
            if (
              oVal.label === attr.label &&
              (variant.product.stock_status === labels.lbl_in_stock ||
                variant.product.quantity > 0)
            ) {
              inStockOptionList.push(oVal);
            }
          }
        }
      }

      const uniqueinStockOptionList = inStockOptionList.filter(
        (item, index) => inStockOptionList.indexOf(item) === index
      );
      let optionObj = {};

      optionObj[option.attribute_code] = uniqueinStockOptionList;

      optList.push(optionObj);
    });
  }

  let regularPrice,
    regularPriceString,
    finalPrice,
    finalPriceString,
    selectedVariant,
    small_image,
    promoTag,
    promoForDeal,
    nonPromoArray,
    vasDescription;

  let optionObj = {};

  if (
    __typename === labels.lbl_product_typeName_configurable
    && cartProduct?.product?.variants !== undefined
    && cartProduct?.product?.variants?.length > 0
  ) {
    const getLabel = (label) => {
      const headingObj = cartProduct?.product?.configurable_options.find(
        (config) => config.attribute_code === label[0]
      );

      return headingObj?.label;
    };

    optList.forEach((obj) => {
      cartProduct?.configurable_options.forEach((addedOption) => {
        if (getLabel(Object.keys(obj)) === addedOption.option_label) {
          optionObj[Object.keys(obj)] = addedOption.value_label;
        }
      });
    });
    selectedVariant = getSelectedVariant(
      cartProduct?.product?.variants,
      optionObj
    );

    small_image = selectedVariant?.product?.small_image?.url;
    promoTag = selectedVariant?.product?.promotion_tag_label;
  } else {
    small_image = cartProduct?.product?.small_image?.url;
    promoTag = cartProduct?.product?.promotion_tag_label;
  }

  if (isDealProduct || isVASProduct) {
    finalPrice = isDealProduct
      ? cartProduct?.product?.monthly_recurring
      : cartProduct?.monthly_recurring;
    regularPrice = cartProduct?.product?.old_monthly_recurring;
    finalPriceString = `R${formatNumbersWithComma(finalPrice)} × ${
      cartProduct?.product?.payment_terms_label
        ? cartProduct?.product?.payment_terms_label
        : paymentTerms
    }`;
    regularPriceString = `R${formatNumbersWithComma(regularPrice)} × ${
      cartProduct?.product?.payment_terms_label
        ? cartProduct?.product?.payment_terms_label
        : paymentTerms
    }`;

    if (isDealProduct) {
      promoForDeal = cartProduct?.product?.items.find(
        (deal) => deal.title === "Promo"
      )?.options[0]?.label;
      const nonPromoValues = cartProduct?.product?.items.filter(
        (deal) => deal.title !== "Promo" && deal.title !== "Smartphones"
      );

      nonPromoArray = nonPromoValues.map((nPmv) =>
        nPmv.options.reduce((productAcc, prod) => {
          if (prod?.is_hidden_product === "0") {
            productAcc.push(prod.label);
          }

          return productAcc;
        }, [])
      )
      .flat();
    }

    if (isVASProduct) {
      let categories = cartProduct?.product?.categories.sort(
        (a, b) => b.level - a.level
      )[0];

      vasDescription = cartProduct?.product?.description;

      if (
        cartProduct?.product?.image.url.match("No_image")
        || cartProduct?.product?.image.url == null
      ) {
        small_image = categories?.image;
      } else {
        small_image = cartProduct?.product?.image.url;
      }
    } else {
      small_image = cartProduct?.product?.primary_product_image;
    }
  } else {
    finalPrice = row_total_including_tax?.value;
    regularPrice = row_total_original?.value;
    finalPriceString = `R${formatNumbersWithComma(finalPrice)}`;
    regularPriceString = `R${formatNumbersWithComma(regularPrice)}`;
  }

  useEffect(() => {
    if (cartProduct?.configurable_options?.length > 0) {
      let options_attr = [];

      cartProduct.configurable_options.forEach((val) => {
        options_attr.push({
          id: val?.id,
          value_string: val?.value_id,
        });
      });

      if (options_attr.length > 0) {
        setOptionsAttributes(options_attr);
      }
    }
  }, [cartProduct]);

  const removeProductFromCart = async () => {
    showSpinner();

    const result = await deleteItemsFromCheckout(cartId, cartProduct.id);

    hideSpinner();

    if (result?.removeItemFromCart?.cart) {
      setShowModal(false);
      displaySnackBar(true, name);

      Analytics.link({
        ...Analytics.getUtagData(),
        link_type: "o",
        page_tool_event: "use",
        page_tool_name: `checkout: review order: ${customerStatus}: remove product`,
        filter_query: cartProduct?.product?.name,
      });
    }
  };

  const promotionLabelColor = LabelConfiguration(promoTag ? promoTag : "");

  const showOptions = () => {
    setShowModal(true);
  };

  const closeOptions = (type, content = "", optionsAttr) => {
    setShowModal(false);

    if (type && type == "confirmModal") {
      setUpdatedOptionsAttributes(optionsAttr);
      displayConfirmModel(content);
    }
  };

  const renderChangeLable = () => {
    setModalShow(true);
  };

  const closeChangeable = () => {
    setModalShow(false);
  };

  const unAvailable =
    cartProduct?.product?.stock_status === labels.lbl_out_of_stock;

  const stepIncrement = async () => {
    showSpinner();

    let qty;

    qty = cartProduct?.quantity + 1;

    await updateItemsofCart(
      cartId,
      cartProduct.id,
      qty,
      optionsAttributes,
      customizable_options
    );

    hideSpinner();
  };

  const stepDecrement = async () => {
    showSpinner();
    let qty;

    if (cartProduct?.quantity > 1) {
      qty = cartProduct?.quantity - 1;
      await updateItemsofCart(
        cartId,
        cartProduct.id,
        qty,
        optionsAttributes,
        customizable_options
      );
    }

    hideSpinner();
  };

  const PriceComponent = (
    <>
      {!isDealProduct && !isVASProduct && (
        <div
          className={styles["qty-wrapper"]}
          id={`${selectedQuantity}-qty-parent-inlineitem`}
        >
          <div style={{ top: 0 }}>
            <StepCounter
              id={cartProduct?.id}
              value={cartProduct?.quantity}
              stepDecrement={stepDecrement}
              stepIncrement={stepIncrement}
            />
          </div>
        </div>
      )}

      <div className={styles["price-wrapper"]}>
        { unAvailable 
          ? (
            <div className={styles["info-text"]}>Currently Unavailable</div>
          ) 
          : (
          <>
            {finalPrice !== regularPrice && regularPrice && (
              <label
                className={styles["discount"]}
                id={`regular-price-inlineitem`}
              >
                {regularPriceString}
              </label>
            )}

            {finalPrice && (
              <label className={styles["price"]} id={`final-price-inlineitem`}>
                {finalPriceString}
              </label>
            )}
          </>
        )}
      </div>
    </>
  );

  const optionValues = optionObj && Object.values(optionObj);

  const RenderProductComponent = () => {
    if (isDealProduct) {
      return (
        <CustomContainer className={styles["cart"]}>
          <CustomContainer className={styles["cart-product"]}>
            <RenderProductInfo />
            <RenderPrice />
          </CustomContainer>

          <RenderDealInfo />
          <RenderPrmoTagAndButton />
        </CustomContainer>
      );
    } else {
      return (
        <CustomContainer className={styles["cart"]}>
          <CustomContainer className={styles["cart-product"]}>
            <RenderProductInfo />
            <RenderPrice />
          </CustomContainer>

          <RenderPrmoTagAndButton />
        </CustomContainer>
      );
    }
  };

  const RenderProductInfo = () => {
    if (isDealProduct || isVASProduct) {
      return (
        <CustomContainer className={styles["cart-product__info"]}>
          <Image
            img_path={small_image}
            className={
              !isVASProduct
                ? styles["product-image"]
                : styles["vas-product-image"]
            }
            alt="image"
          />

          <div className={styles["specs"]}>
            <label className={styles["label"]}>
              {isDealProduct ? primary_product_name : name}
            </label>
            <RenderSelectedSpecs />

            {promoTag && isTablet && (
              <CustomContainer className={styles["tag"]}>
                <span className={styles["tag__icon"]}>&nbsp;</span>
                <span
                  className={styles["tag__label"]}
                  style={{ color: promotionLabelColor }}
                >
                  {promoTag}
                </span>
              </CustomContainer>
            )}

            <CustomContainer>
              {isVASProduct && (
                <>
                  <div className={styles["vas-desc"]}>
                    <label className={styles["vas-desc--text"]}>
                      <div
                        dangerouslySetInnerHTML={createMarkup(
                          vasDescription.html
                        )}
                      ></div>
                    </label>
                  </div>
                </>
              )}
            </CustomContainer>
          </div>

          {isMobile && isVASProduct && (
            <Image
              img_path={`${imagePrefix}/assets/images/menu-dots.svg`}
              img_width="20px"
              img_height="20px"
              className={styles["cart-product--price-container"]}
              onClick={showOptions}
              id={`${cartProduct?.id}-options`}
            />
          )}
        </CustomContainer>
      );
    } else {
      return (
        <CustomContainer className={styles["cart-product__info"]}>
          <Image
            img_path={small_image}
            className={styles["product-image"]}
            alt="image"
          />

          <div className={styles["specs"]}>
            <label className={styles["label"]}>{name}</label>
            <RenderSelectedSpecs />
          </div>

          <Image
            img_path={`${imagePrefix}/assets/images/menu-dots.svg`}
            img_width="1.25rem"
            img_height="1.25rem"
            className={styles["dots"]}
            onClick={showOptions}
            id="three-dots-changing"
          />
        </CustomContainer>
      );
    }
  };

  const RenderSelectedSpecs = () => {
    const colorSelection = cartProduct?.colorSelection?.label
      ? ( <span> | { cartProduct?.colorSelection?.label} </span> )
    : null;

    if (__typename !== labels.lbl_product_typeName_simple) {
      let op = (optionValues && optionValues.length > 0) || (dealOptions && dealOptions.length > 0)
        ? (
          <div className={styles["value"]}>
            <label id={`storage-value`}>
              {(optionValues && optionValues[0]) ||
                (dealOptions && dealOptions[0])}
            </label>
            {(optionValues && optionValues.length > 1) ||
            (dealOptions && dealOptions.length > 1) ? (
              <label className={styles["line-separator"]}>|</label>
            ) : null}
          </div>
        )
        : null;

      let op1 = (optionValues && optionValues.length > 1) || (dealOptions && dealOptions.length > 1)
        ? (
          <label className={styles["value"]} id={`color-value`}>
            {optionValues[1] || dealOptions[1]}
          </label>
        )
        : null;

      let ch = __typename === labels.lbl_product_typeName_configurable
        ? (
          <label className={styles["change"]} onClick={renderChangeLable}>
            Change
          </label>
        ) 
        : null;

      if (op || op1 | ch) {
        return (
          <div className={styles["display-specs"]}>
            {op}
            {op1}
            {colorSelection}
            {ch}
          </div>
        );
      }
    }

    return (
      <div>
        { colorSelection }
      </div>
    );
  };

  const RenderPrice = () => {
    if ((isDealProduct && !isTablet) || !isDealProduct) {
      return (
        <CustomContainer className={styles["cart-product__price"]}>
          {PriceComponent}
        </CustomContainer>
      );
    }

    return null;
  };

  const RenderDealInfo = () => {
    return (
      <CustomContainer className={styles["deal-product"]}>
        <label className={styles["deal-promo"]}>
          {labels.deal_details.lbl_on_a} <span>{promoForDeal}</span>
          {` ` + labels.deal_details.lbl_with}
        </label>

        <CustomContainer className={styles["deal-highlight"]}>
          {getHighlights(cartProduct?.product).map((item) => (
            <IconWithText
              key={item.value}
              icon={item.icon}
              value={item.value}
              description={item.displayUnit}
              valueStyle={styles["deal-highlight__value"]}
              typeStyle={styles["deal-highlight__type"]}
              imageClass={styles["deal-highlight__icon"]}
              descriptionStyle={styles["deal-highlight__description"]}
            />
          ))}
        </CustomContainer>

        <CustomContainer
          className={styles["additional-item"]}
          id="additional-item"
        >
          { nonPromoArray?.map((value) => (
            <IconWithText
              key={value}
              icon={`${imagePrefix}/assets/images/add-copy.svg`}
              value={value}
              imageClass={styles["img"]}
              valueStyle={styles["value"]}
              className={styles["icon-text"]}
              descriptionStyle={styles["description"]}
            />
          ))}
        </CustomContainer>

        { isTablet && (
          <CustomContainer className={styles["cart-product__price"]}>
            {PriceComponent}
          </CustomContainer>
        )}
      </CustomContainer>
    );
  };

  const RenderPrmoTagAndButton = () => {
    if (isDealProduct) {
      if (promoTag) {
        return (
          <CustomContainer
            className={`${styles["cart-product__buttons"]} ${styles["deal-buttons"]}`}
          >
            <CustomContainer className={`${styles["collapse"]}`}>
              <CustomContainer className={styles["promotion"]}>
                <span className={styles["icon"]}>&nbsp;</span>

                <LabelText className={styles["main-label"]}>
                  { labels.lbl_promotion }

                  <span
                    className={styles["sub-label"]}
                    style={{ color: promotionLabelColor }}
                  >
                    {promoTag}
                  </span>
                </LabelText>
              </CustomContainer>
            </CustomContainer>
          </CustomContainer>
        );
      }

      return null;
    } else {
      return (
        <CustomContainer className={styles["cart-product__buttons"]}>
          <CustomContainer className={`${styles["collapse"]}`}>
            <CustomContainer className={styles["promotion"]}>
              {promoTag && (
                <>
                  <span className={styles["icon"]}>&nbsp;</span>
                  <LabelText className={styles["main-label"]}>
                    {labels.lbl_promotion}
                    <span
                      className={styles["sub-label"]}
                      style={{ color: promotionLabelColor }}
                    >
                      {promoTag}
                    </span>
                  </LabelText>
                </>
              )}
            </CustomContainer>

            <CustomContainer className={styles["trash"]}>
              <ButtonWithIcon
                labelText={labels.lbl_remove}
                img_url_inactive={`${imagePrefix}/assets/images/icon-trash-inactive.svg`}
                img_url_active={`${imagePrefix}/assets/images/icon-trash-active.svg`}
                img_width={18}
                img_height={18}
                clickHandler={removeProductFromCart}
                className={styles["btnIcon"]}
              />
            </CustomContainer>
          </CustomContainer>
        </CustomContainer>
      );
    }
  };

  const displayConfirmModel = (content) => {
    setConfirmModalContent(content);
    setShowConfirmModal(true);
  };

  const cancelConfirmModel = () => {
    setShowConfirmModal(false);
    resetConfirmModalContent();
  };

  const approveConfirmModel = async () => {
    setShowConfirmModal(false);
    showSpinner();

    await updateItemsofCart(
      cartId,
      cartProduct.id,
      selectedQuantity,
      updatedOptionsAttributes,
      customizable_options
    );

    hideSpinner();
    resetConfirmModalContent();
  };

  const resetConfirmModalContent = () => {
    setConfirmModalContent("");
    setUpdatedOptionsAttributes([]);
  };

  const renderPage = () => {
    setUpdatePage(true);
  };

  useEffect(() => {
    setUpdatePage(false);
  }, [updatePage]);

  return (
    <>
      {__typename === labels.lbl_product_typeName_configurable && (
        <ChangeLabelWithOutOfStock
          renderPage={renderPage}
          selectedOptions={optionObj}
          optList={optList}
          variant="review"
          show={modalShow}
          centered
          onHide={closeChangeable}
          closeChangeable={closeChangeable}
          configProduct={__typename === labels.lbl_product_typeName_configurable
            ? cartProduct
            : null
          }
          originalPrice={finalPrice}
          customerStatus={customerStatus}
          buyOptionId={buyOptionId}
          buyOptionTypeId={buyOptionTypeId}
        />
      )}

      <RenderProductComponent />

      <Modal
        show={showModal}
        onHide={closeOptions}
        dialogClassName="custom-dialog"
      >
        <CartProductOptions
          renderPage={renderPage}
          selectedOptions={optionObj}
          optList={optList}
          variant="review"
          cartProduct={cartProduct}
          show={showModal}
          originalPrice={finalPrice}
          onHide={closeOptions}
          onSnack={displaySnackBar}
          promoTag={promoTag}
          displayConfirmModel={displayConfirmModel}
          removeCartProduct={removeProductFromCart}
          buyOptionId={buyOptionId}
          buyOptionTypeId={buyOptionTypeId}
        />
      </Modal>

      <ConfirmModal
        show={showConfirmModal}
        text={confirmModalContent}
        handleConfirm={approveConfirmModel}
        handleCancel={cancelConfirmModel}
      />
    </>
  );
};

InlineItem.propTypes = {
  cartId: PropTypes.string,
  cartProduct: PropTypes.object,
  deleteItemsFromCheckout: PropTypes.func,
  updateItemsofCart: PropTypes.func,
  displaySnackBar: PropTypes.func,
  customerStatus: PropTypes.string,
  dealSku: PropTypes.string,
  paymentTerms: PropTypes.string,
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartDetails,
});

export default connect(mapStateToProps, {
  deleteItemsFromCheckout,
  updateItemsofCart,
})(InlineItem);
